import {
  Input,
  OnInit,
  Directive,
  ElementRef,
  HostListener,
} from '@angular/core';
import { TelService } from '../tel.service';

@Directive({ selector: '[phoneInput]' })
export class PhoneInputDirective implements OnInit {
  @Input() countryAbbr?: string;

  constructor(
    private elementRef: ElementRef,
    private readonly telService: TelService,
  ) { }

  ngOnInit(): void {
    this.elementRef.nativeElement.value = this.transform(this.elementRef.nativeElement.value);
  }

  transform(phone: string): string {
    return this.telService.format(phone, this.countryAbbr);
  }

  @HostListener('keyup', ['$event.target.value'])
  change(): void {
    this.elementRef.nativeElement.value = this.transform(this.elementRef.nativeElement.value);
  }
}
